/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_CHARTS_DATA = "GET_CHARTS_DATA";

export const SET_TENANT_CODE_HEADER = "SET_TENANT_CODE_HEADER";

export const GET_LIST_TENANT_HEADER = "GET_LIST_TENANT_HEADER";
export const GET_LIST_TENANT_HEADER_SUCCESS = "GET_LIST_TENANT_HEADER_SUCCESS";
export const GET_LIST_TENANT_HEADER_FAIL = "GET_LIST_TENANT_HEADER_FAIL";

// Đơn vị cha
export const SET_BU_TENANT_HEADER = "SET_BU_TENANT_HEADER";
export const SET_BU_TENANT_HEADER_SUCCESS = "SET_BU_TENANT_HEADER_SUCCESS";
export const SET_BU_TENANT_HEADER_FAIL = "SET_BU_TENANT_HEADER_FAIL";

export const GET_LIST_BU_TENANT_HEADER = "GET_LIST_BU_TENANT_HEADER";
export const GET_LIST_BU_TENANT_HEADER_SUCCESS =
  "GET_LIST_BU_TENANT_HEADER_SUCCESS";
export const GET_LIST_BU_TENANT_HEADER_FAIL = "GET_LIST_BU_TENANT_HEADER_FAIL";
export const RESET_GET_LIST_BU_TENANT_HEADER =
  "RESET_GET_LIST_BU_TENANT_HEADER";

// Chi nhánh thuộc đơn vị
export const SET_BU_STORE_HEADER = "SET_BU_STORE_HEADER";
export const SET_BU_STORE_HEADER_SUCCESS = "SET_BU_STORE_HEADER_SUCCESS";
export const SET_BU_STORE_HEADER_FAIL = "SET_BU_STORE_HEADER_FAIL";
export const RESET_SET_BU_STORE_HEADER = "RESET_SET_BU_STORE_HEADER";

export const GET_LIST_BU_STORE_HEADER = "GET_LIST_BU_STORE_HEADER";
export const GET_LIST_BU_STORE_HEADER_SUCCESS =
  "GET_LIST_BU_STORE_HEADER_SUCCESS";
export const GET_LIST_BU_STORE_HEADER_FAIL = "GET_LIST_BU_STORE_HEADER_FAIL";
export const RESET_GET_LIST_BU_STORE_HEADER = "RESET_GET_LIST_BU_STORE_HEADER";

export const GET_CHARTS_DATA_MESSAGE_STATUS = "GET_CHARTS_DATA_MESSAGE_STATUS";
export const GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS =
  "GET_CHARTS_DATA_MESSAGE_STATUS_SUCCESS";
export const GET_CHARTS_DATA_MESSAGE_STATUS_FAIL =
  "GET_CHARTS_DATA_MESSAGE_STATUS_FAIL";

// SET_METHOD_SIGN
export const SET_METHOD_SIGN = "SET_METHOD_SIGN";
export const SET_METHOD_SIGN_SUCCESS = "SET_METHOD_SIGN_SUCCESS";
export const SET_METHOD_SIGN_FAIL = "SET_METHOD_SIGN_FAIL";
export const RESET_SET_METHOD_SIGN = "RESET_SET_METHOD_SIGN";
